import { RefreshCwIcon } from 'lucide-react';
import { Button, ButtonProps } from './button';

type Props = ButtonProps & {
  loading?: boolean;
  buttonRef?: React.RefObject<HTMLButtonElement>;
};

export const LoadingButton: React.FC<Props> = ({ loading, children, buttonRef, ...props }) => {
  return (
    <Button ref={buttonRef} disabled={loading} {...props}>
      {loading && <RefreshCwIcon className="mr-2 size-4 animate-spin" />}
      {children}
    </Button>
  );
};
